import React, { useCallback, useEffect, useState } from 'react';

import { Button, DatePicker, Form, Input, Space, Spin, message } from 'antd';
import dayjs from 'dayjs';

import sessionManager, { eVariableType } from '../../SessionManager';
import { GetErrorMessage } from '../../Utility';
import api from '../../api';
import stringres from '../../translations/stringres';

interface ViaggioAddEditProps {
    idViaggio: number | null;
    onClose: () => void;
    width: string;
}

export default function ViaggioAddEdit(props: ViaggioAddEditProps) {
    const [isLoading, setIsLoading] = useState(false);
    const [frm]: any = Form.useForm();

    const LoadData = useCallback(async () => {
        try {
            if (props.idViaggio !== null) {
                const res = await api.get(
                    'CRM/Viaggio?idViaggio=' +
                        props.idViaggio +
                        '&idSocieta=' +
                        sessionManager.get(eVariableType.IDSocieta)
                );
                if (res.data !== null) {
                    frm.setFieldValue('descrizioneViaggio', res.data[0].descrizioneViaggio);
                    frm.setFieldValue('dataPartenza', dayjs(res.data[0].dataPartenza));
                    frm.setFieldValue('dataRientro', dayjs(res.data[0].dataRientro));
                    frm.setFieldValue('codNazione', res.data[0].codNazione);
                }
            }
        } catch (error) {
            GetErrorMessage(error);
        }
    }, [props.idViaggio, frm]);

    useEffect(() => {
        LoadData(); // Chiamata alla funzione LoadData
    }, [LoadData]);

    async function onSalva() {
        try {
            setIsLoading(true);
            const dt = {
                idViaggio: props.idViaggio,
                idSocieta: sessionManager.get(eVariableType.IDSocieta),
                dataPartenza: frm.getFieldValue('dataPartenza'),
                dataRientro: frm.getFieldValue('dataRientro'),
                idOperatore: sessionManager.get(eVariableType.IDOperatore),
                codNazione: frm.getFieldValue('codNazione'),
                descrizioneViaggio: frm.getFieldValue('descrizioneViaggio'),
            };

            const res = await api.post('CRM/Viaggi/Insert', dt);

            if (res != null) {
                message.success(stringres.t('successo').toString());
                LoadData();
                props.onClose();
            }
        } catch (error) {
            GetErrorMessage(error);
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <div style={{ margin: '20px', width: props.width }}>
            <Spin spinning={isLoading}>
                <Form form={frm} onFinish={onSalva}>
                    <Form.Item name="descrizioneViaggio" rules={[{ required: true }]}>
                        <Input.TextArea rows={4} placeholder={stringres.t('descrizione').toString()}></Input.TextArea>
                    </Form.Item>
                    <Form.Item>
                        <Space size={2}>
                            <Form.Item
                                style={{ margin: '0px' }}
                                name="dataPartenza"
                                className="Form-item-inline2componenti"
                                rules={[{ required: true }]}
                            >
                                <DatePicker
                                    style={{ width: '150px' }}
                                    placeholder={stringres.t('dataInizio').toString()}
                                ></DatePicker>
                            </Form.Item>
                            <Form.Item
                                style={{ margin: '0px' }}
                                name="dataRientro"
                                className="Form-item-inline2componenti"
                            >
                                <DatePicker
                                    style={{ width: '150px' }}
                                    placeholder={stringres.t('dataFine').toString()}
                                ></DatePicker>
                            </Form.Item>
                            <Form.Item
                                style={{ margin: '0px' }}
                                name="codNazione"
                                className="Form-item-inline3componenti"
                            >
                                <Input maxLength={3} placeholder={stringres.t('nazione').toString()}></Input>
                            </Form.Item>
                        </Space>
                    </Form.Item>
                    <Form.Item name="">
                        <div style={{ textAlign: 'right' }}>
                            <Button type="primary" htmlType="submit">
                                {stringres.t('conferma').toString()}
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
            </Spin>
        </div>
    );
}
